import { Link } from 'react-router-dom';
import { getTopRatedComics } from '@/mocks/comics';

export default function RankingSection() {
  const topRated = getTopRatedComics(10);

  return (
    <section className="w-full bg-background-100/70 border-y border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            <a href="#ranking">人气排行榜</a>
          </h2>
          <p className="text-sm text-foreground-500 mt-1"><strong>韩漫大全</strong>中评分最高的作品</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {topRated.slice(0, 5).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full font-bold text-sm flex-shrink-0 ${
                index === 0
                  ? 'bg-accent-500 text-background-50'
                  : index === 1
                  ? 'bg-secondary-500 text-background-50'
                  : index === 2
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>
              <img
                src={comic.coverImage}
                alt={`${comic.title} - 韩漫在线免费阅读`}
                className="w-12 h-16 rounded object-cover object-top flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <div className="flex items-center gap-3 mt-1">
                  <div className="flex items-center gap-0.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px] text-accent-500"></i>
                    </div>
                    <span className="text-xs text-foreground-600">{comic.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comic.status}</span>
                </div>
              </div>
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}